import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PendingEmailConfirmationService {
  private readonly FLAG_KEY = '__pendingEmailConfirmation';
  private readonly TOKEN_KEY = '__PENDING_LOGIN_ID_TOKEN__';

  /** Stash a provisional (pre-verification) id token in a transient window property. */
  public stashToken(token: string): void {
    try {
      (window as any)[this.TOKEN_KEY] = token;
    } catch {}
  }

  /** Retrieve the currently stashed token without consuming it (may return null). */
  public getStashedToken(): string | null {
    try {
      return (window as any)[this.TOKEN_KEY] || null;
    } catch {
      return null;
    }
  }

  /** Retrieve & remove the stashed token in a single step (idempotent). */
  public consumeStashedToken(): string | null {
    const tok = this.getStashedToken();
    if (tok) this.clearStash();
    return tok;
  }

  /** Mark the session as pending email confirmation and clear any provisional token. */
  public markPending(): void {
    try {
      localStorage.setItem(this.FLAG_KEY, '1');
      this.clearStash();
    } catch {}
  }

  /** Clear the pending confirmation flag and any lingering provisional token. */
  public clearPending(): void {
    try {
      localStorage.removeItem(this.FLAG_KEY);
      this.clearStash();
    } catch {}
  }

  /** Determine whether the user is currently in a pending email confirmation state. */
  public isPending(): boolean {
    try {
      return localStorage.getItem(this.FLAG_KEY) === '1';
    } catch {
      return false;
    }
  }

  /** Remove only the provisional token from the window scope. */
  private clearStash(): void {
    try {
      delete (window as any)[this.TOKEN_KEY];
    } catch {}
  }
}
